<template>
  <div>
    <v-snackbar :top="y === 'top'" v-model="snackbar">
      {{ text }}
      <v-btn color="primary" flat @click="snackbar = false">X</v-btn>
    </v-snackbar>
    <!-- <v-layout justify-center mt-3 row wrap>
      <v-flex xs6 sm2 md2 mx-4 my-2 v-if="activeAccounts">
        <v-card
          min-width="120px"
          hover
          color="light-green"
          height="80px"
          class="rounded-card"
        >
          <v-card-text>
            <v-layout wrap class="white--text" justify-center align-center>
              <v-flex xs12>
                <h3 class="title">Active Services</h3>
              </v-flex>
              <v-flex xs12>
                <h2>{{ activeAccounts.length }}</h2>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs6 sm2 md2 mx-4 my-2 v-if="changeRequests">
        <v-card
          min-width="120px"
          hover
          color="orange"
          height="80px"
          class="rounded-card"
        >
          <v-card-text>
            <v-layout wrap class="white--text" justify-center align-center>
              <v-flex xs12>
                <h3 class="title">Change Requests</h3>
              </v-flex>
              <v-flex xs12>
                <h2 class="font-weight-bold">{{ changeRequests.length }}</h2>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout> -->
    <v-layout row wrap mt-2 mx-2>
      <v-flex xs12 sm12 md4 lg4 xl4 my-1>
        <v-card min-width="250px" class="rounded-card" style="height: 320px">
          <h2 class="dark-grey--text">My Info</h2>
          <v-card-text style="overflow-y: auto; max-height:280px">
            
            <v-layout justify-center>
              <v-btn
                small
                dark
                round
                color="primary"
                @click="resetDialogFields()"
                >RESET PASSWORD</v-btn
              >
              <v-btn
                small
                round
                class="primary"
                @click="editingContact = !editingContact"
              >
                <v-icon small color="white">edit</v-icon>Edit
              </v-btn>
              <!-- <v-btn
                small
                round
                color="primary"
                v-if="editingContact"
                @click="editContactInfo()"
                >Done
              </v-btn> -->
            </v-layout>
            <v-layout wrap>
              <v-flex xs12 sm12 md12 text-xs-left>
                <v-layout justify-left align-center>
                  <v-flex xs6>
                    <h2 class="subheading grey--text font-weight-bold">
                      Name:
                    </h2>
                  </v-flex>
                  <v-flex xs6>
                    <h3 class="grey--text font-weight-light">
                      {{ contact.name }}
                    </h3>
                  </v-flex>
                 
                </v-layout>
                <v-layout justify-left align-center>
                  <v-flex xs6>
                    <h2 class="subheading grey--text font-weight-bold">
                      Surname:
                    </h2>
                  </v-flex>
                  <v-flex xs6 >
                    <h3 class="grey--text font-weight-light">
                      {{ contact.surname }}
                    </h3>
                  </v-flex>
                  
                </v-layout>
                <v-layout justify-left align-center>
                  <v-flex xs6>
                    <h2 class="subheading grey--text font-weight-bold">
                      ID Number:
                    </h2>
                  </v-flex>
                  <v-flex xs6 >
                    <h3 class="grey--text font-weight-light">
                      {{ contact.idNumber }}
                    </h3>
                  </v-flex>
                  
                </v-layout>
                <v-layout justify-left align-center>
                  <v-flex xs6>
                    <h2 class="subheading grey--text font-weight-bold">
                      Mobile Number:
                    </h2>
                  </v-flex>
                  <v-flex xs6 >
                    <h3 class="grey--text font-weight-light">
                      {{ contact.mobileNumber }}
                    </h3>
                  </v-flex>
                  
                </v-layout>
                <v-layout justify-left align-center>
                  <v-flex xs6>
                    <h2 class="subheading grey--text font-weight-bold">
                      Telephone Number:
                    </h2>
                  </v-flex>
                  <v-flex xs6 >
                    <h3 class="grey--text font-weight-light">
                      {{ contact.telephoneNumber }}
                    </h3>
                  </v-flex>
                  
                </v-layout>
                <v-layout justify-left align-center>
                  <v-flex xs6>
                    <h2 class="subheading grey--text font-weight-bold">
                      Email Address:
                    </h2>
                  </v-flex>
                  <v-flex xs6 >
                    <h3 class="grey--text font-weight-light">
                      {{ contact.emailAddress }}
                    </h3>
                  </v-flex>
                  
                </v-layout>
                <!-- <v-layout justify-left align-center>
                  <v-flex xs6>
                    <h2 class="subheading grey--text font-weight-bold">
                      ID Document:
                    </h2>
                  </v-flex>
                  <v-flex xs2 v-if="!editingContact">
                    <v-layout>
                      <v-flex xs6>
                        <v-icon color="green" v-if="contact.idDocument"
                          >done</v-icon
                        >
                        <v-icon color="red" v-else>not_interested</v-icon>
                      </v-flex>
                      <v-flex xs6>
                        <a
                          v-if="contact.idDocument !== null"
                          download="idDocument.pdf"
                          :href="contact.idDocument"
                          ><v-icon medium color="primary"
                            >cloud_download</v-icon
                          ></a
                        >
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs2 v-else>
                    <v-layout>
                      <v-flex xs6>
                        <v-icon color="green" v-if="contact.idDocument"
                          >done</v-icon
                        >
                        <v-icon color="red" v-else>not_interested</v-icon>
                      </v-flex>
                      <v-flex xs6>
                        <v-icon
                          @click="$refs.idDocument.click()"
                          medium
                          color="primary"
                          >cloud_upload</v-icon
                        >
                        <input
                          style="display: none"
                          class="file-input"
                          @change="selectFile($event, 'id')"
                          ref="idDocument"
                          type="file"
                        />
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout> -->
                <!-- <v-layout justify-left align-center>
                  <v-flex xs6>
                    <h2 class="subheading grey--text font-weight-bold">
                      Proof of Residence:
                    </h2>
                  </v-flex>
                  <v-flex xs2 v-if="!editingContact">
                    <v-layout>
                      <v-flex xs6>
                        <v-icon color="green" v-if="contact.ficaDocument"
                          >done</v-icon
                        >
                        <v-icon color="red" v-else>not_interested</v-icon>
                      </v-flex>
                      <v-flex xs6>
                        <a
                          v-if="contact.ficaDocument !== null"
                          download="ficaDocument.pdf"
                          :href="contact.ficaDocument"
                          ><v-icon medium color="primary"
                            >cloud_download</v-icon
                          ></a
                        >
                      </v-flex>
                    </v-layout>
                  </v-flex>
                  <v-flex xs2 v-else>
                    <v-layout>
                      <v-flex xs6>
                        <v-icon color="green" v-if="contact.ficaDocument"
                          >done</v-icon
                        >
                        <v-icon color="red" v-else>not_interested</v-icon>
                      </v-flex>
                      <v-flex xs6>
                        <v-icon
                          @click="$refs.ficaDocument.click()"
                          medium
                          color="primary"
                          >cloud_upload</v-icon
                        >
                        <input
                          style="display: none"
                          class="file-input"
                          @change="selectFile($event, 'fica')"
                          ref="ficaDocument"
                          type="file"
                        />
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout> -->
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex :key="key" xs12 sm12 md4 lg4 xl4 my-1>
        <v-card class="rounded-card" style="height: 320px">
            <h2 class="dark-grey--text">Documents</h2>

          <v-card-text style="overflow-y: auto; max-height:280px">
            <v-layout justify-center align-center wrap>
              <v-flex
                xs12
                mx-2
                mb-1
                v-for="document in documents"
                :key="document.id"
              >
                <v-card flat color="white">
                  <v-layout justify-left align-center wrap>
                    <v-flex xs4 v-if="document.signatureRequired">
                      <h4
                        class="grey--text font-weight-light"
                        v-if="document.signatureRequired && document.signed"
                      >
                        {{ formatDate(new Date(document.updatedAt)) }}
                      </h4>
                      <v-chip
                        color="orange"
                        class="white--text"
                        v-else-if="document.signatureRequired"
                        >Pending</v-chip
                      >
                    </v-flex>
                    <v-flex xs4 v-else>
                      <h4 class="grey--text font-weight-light">
                        {{ formatDate(new Date(document.updatedAt)) }}
                      </h4>
                    </v-flex>
                    <v-flex xs6>
                      <h4 class="grey--text">{{ document.name }}</h4>
                    </v-flex>
                    <v-flex xs2>
                      <v-layout
                        justify-center
                        v-if="
                          !document.signatureRequired ||
                          document.signatureRequired & document.signed
                        "
                      >
                        <v-icon @click="viewFile(document)">open_in_new</v-icon>
                        <v-icon @click="downloadFile(document)"
                          >download</v-icon
                        >
                        <!-- <v-icon color="red" @click="deleteItem(document)">delete</v-icon> -->
                      </v-layout>
                      <v-layout v-else justify-center>
                        <v-btn
                          flat
                          round
                          color="primary"
                          @click="viewAgreement(document)"
                          >View</v-btn
                        >
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
      

      <v-flex
        :key="key"
        xs12
        sm12
        md4
        lg4
        xl4
        my-1
      >
       <v-card class="rounded-card" style="height: 320px">
          <v-card-text>
            <h2 class="dark-grey--text">Tickets <v-icon>add_circle_outline</v-icon></h2>
            <v-container fill-height>
              <v-layout
              
              wrap
              justify-center
              align-center
            >
            <div v-if="tickets.length>0"></div>
            <span v-else class="grey--text">You currently have no tickets.</span>
            
            </v-layout>
            </v-container>
          </v-card-text>
       </v-card>
      </v-flex>

      <!-- <v-flex
        :key="key"
        v-if="allLocations.length > 0"
        xs12
        sm12
        md4
        lg4
        xl4
        my-1
      >
        <v-card class="rounded-card" style="height: 320px">
          <v-card-text>
            <h2 class="dark-grey--text">My Locations</h2>
            <v-container fill-height>
              <v-layout
              
              wrap
              justify-center
              align-center
            >
              <v-flex
                xs12
                sm12
                md12
                v-for="locationInfo in allLocations"
                :key="locationInfo.id"
                text-xs-left
              >
                <v-card min-width="300px" class="ma-2 pa-2" hover>
                  <v-tile wrap>
                    <v-layout>
                      <v-flex xs3>
                        <h2 class="subheading grey--text font-weight-bold">
                          Location:
                        </h2>
                      </v-flex>
                      <v-flex xs9>
                        <h3 class="grey--text font-weight-light">
                          {{ locationInfo.location.locationNetwork.name }}:
                          {{ locationInfo.location.locationDescription }}
                        </h3>
                      </v-flex>
                    </v-layout>
                    <v-spacer></v-spacer>
                    <v-tile-content class="grey--text">
                      <v-layout>
                        <v-flex xs3>
                          <h2 class="subheading grey--text font-weight-bold">
                            Passive Install:
                          </h2>
                        </v-flex>
                        <v-flex xs9>
                          <v-chip
                            v-if="locationInfo.location.fibrePulled == true"
                            small
                            color="light-green"
                            class="white--text"
                            >Complete</v-chip
                          >
                          <v-chip v-else small color="red" class="white--text"
                            >Incomplete</v-chip
                          >
                        </v-flex>
                      </v-layout>

                      <v-layout>
                        <v-flex xs3>
                          <h2 class="subheading grey--text font-weight-bold">
                            Active Install:
                          </h2>
                        </v-flex>
                        <v-flex xs9>
                          <v-chip
                            v-if="
                              locationInfo.location.equipmentInstalled == true
                            "
                            small
                            color="light-green"
                            class="white--text"
                            >Complete</v-chip
                          >
                          <v-chip v-else small color="red" class="white--text"
                            >Incomplete</v-chip
                          >
                        </v-flex>
                      </v-layout>
                    </v-tile-content>
                  </v-tile>
                </v-card>
              </v-flex>
            </v-layout>
            </v-container>
            
          </v-card-text>
        </v-card>
      </v-flex> -->


      <v-flex :key="key" xs12 sm12 md6 my-1>
        <v-card class="rounded-card" >
          <v-card-text>
            <h2 class="dark-grey--text">Billing</h2>
            <v-tabs grow>
              <v-tab @click="billingTab = 'invoices'">Invoices <v-chip>{{invoices.length}}</v-chip></v-tab>

              <v-tab @click="billingTab = 'quote'">Quotes <v-chip>{{quotes.length}}</v-chip></v-tab>
            </v-tabs>
            <div v-if="billingTab == 'invoices'">
              <v-data-table
                :headers="transactionHeaders"
                :items="invoices"
                :rows-per-page-items="[5]"
              >
                <template v-slot:items="props">
                  <td > {{props.item.DocumentNumber}}</td>
                  <td > {{formatDate(props.item.Date)}}</td>
                  <td > {{props.item.Total | currency}}</td>
                  <td >
                    <v-chip small v-if="props.item.AmountDue<=0" color="light-green" class="white--text">Paid</v-chip>
                    <v-chip small v-else-if="props.item.AmountDue>0&&props.item.AmountDue<props.item.Total" color="orange" class="white--text">Partially Paid</v-chip>
                    <v-chip small v-else-if="props.item.AmountDue == props.item.Total" color="red" class="white--text">Unpaid</v-chip>

                  </td>

                </template>
              </v-data-table>
            </div>
            
            <div v-if="billingTab == 'quote'">
                    <v-data-table :items="quotes" :rows-per-page-items="5" :headers="quoteHeaders">
                       <template v-slot:items="props">
                         <td>
                           <v-btn flat color="primary" @click="viewQuote(props.item)">View</v-btn>
                         </td>
                         <td>{{props.item.document}}</td>
                         <td>{{formatDate(props.item.date)}}</td>
                         <td>{{formatDate(props.item.expires)}}</td>
                         <td>
                           <v-chip color="red" class="white--text" v-if="new Date() > new Date(props.item.expires)">Expired</v-chip>
                           <v-chip color="light-green" class="white--text" v-else-if="props.item.isAccepted">Accepted</v-chip>
                           <v-chip color="orange" class="white--text" v-else-if="props.item.isAccepted==null">Pending</v-chip>
                           <v-chip color="red" class="white--text" v-else-if="!props.item.isAccepted">Rejected</v-chip>
                         </td>
                       </template>
                    </v-data-table>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex grow>
        <v-card class="rounded-card">
          
          <v-card-text>
            <h2>My Services <v-chip>{{activeAccounts.length}}</v-chip></h2>
            <v-layout justify-center align-center fill-height v-if="activeAccounts.length>0">
              <v-flex xs1>
                <v-icon v-if="selectedServiceAccountIndex>0" @click="selectedServiceAccountIndex--">chevron_left</v-icon><v-icon v-else disabled>chevron_left</v-icon>
                </v-flex>
              <v-flex xs8>
                <v-card class="rounded-card" flat color="white" >
                          <v-card hover class="ma-1 pa-2" :key="selectedServiceAccountIndex">
                <v-layout align-center wrap>
                  <!-- <v-avatar class="white" size="150px"> -->
                    <v-img
                    height="150px"
                      contain
                      alt="Avatar"
                      :key="
                        activeAccounts[selectedServiceAccountIndex].current.packagesIsp.customerOrganisation.logo
                      "
                      :src="
                        activeAccounts[selectedServiceAccountIndex].current.packagesIsp.customerOrganisation.logo
                      "
                    />
                  <!-- </v-avatar> -->
                  <v-spacer></v-spacer>
                  <h2 class="grey--text justify-center">
                    {{ activeAccounts[selectedServiceAccountIndex].current.packagesIsp.name }}
                  </h2>
                </v-layout>
                <v-layout dense justify-center align-center wrap color="white">
                  <v-btn
                    color="green"
                    dark
                    class="mx-1"
                    small
                    @click="processRequest('Upgrade')"
                    round
                    >Upgrade</v-btn
                  >
                  <v-btn
                    color="orange"
                    dark
                    class="mx-1"
                    small
                    @click="processRequest('Downgrade')"
                    round
                    >Downgrade</v-btn
                  >
                  <v-btn
                    color="red"
                    dark
                   class="mx-1"
                    small
                    @click="processTermination(activeAccounts[selectedServiceAccountIndex])"
                    round
                    >Terminate</v-btn
                  >
                </v-layout>
                <v-layout justify-center align-center wrap>
                  <v-icon>location_on</v-icon>
                    <h4
                      class="grey--text font-weight-light ml-1"
                      style="
                        display: inline-block;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        overflow: hidden;
                      "
                    >
                      {{ activeAccounts[selectedServiceAccountIndex].current.location.locationDescription }}
                    </h4>

                </v-layout>

                <v-divider></v-divider>
                  <v-tabs centered grow fill-height>
                    <v-tabs-slider color="primary"></v-tabs-slider>
                    <v-tab 
                      @click="
                        activeAccounts[selectedServiceAccountIndex].currentTab = true;
                        activeAccounts[selectedServiceAccountIndex].historyTab = false;
                      "
                      class="grey--text"
                      flat
                      round
                      color="grey"
                      >Current</v-tab
                    >
                    <v-tab
                      @click="
                        activeAccounts[selectedServiceAccountIndex].currentTab = false;
                        activeAccounts[selectedServiceAccountIndex].historyTab = true;
                      "
                      v-if="activeAccounts[selectedServiceAccountIndex].count>0"
                      class="grey--text"
                      flat
                      round
                      color="grey"
                      >History</v-tab
                    >
                  </v-tabs>
                <v-card flat v-show="activeAccounts[selectedServiceAccountIndex].currentTab">
                  <v-layout justify-left align-center wrap>
                    <v-flex
                      class="text-xs-center grey--text"
                      v-if="
                        activeAccounts[selectedServiceAccountIndex].current.fnoActivationDate &&
                        activeAccounts[selectedServiceAccountIndex].current.fnoDeactivationDate === null
                      "
                    >
                      <v-chip
                        dense
                        color="light-green"
                        class="white--text font-weight-bold"
                        >{{ formatDate(activeAccounts[selectedServiceAccountIndex].current.fnoActivationDate) }}</v-chip
                      >-
                      <v-chip
                        color="blue"
                        dense
                        class="white--text font-weight-bold"
                        >Present</v-chip
                      >
                    </v-flex>
                    <v-flex
                      class="text-xs-center grey--text"
                      v-else-if="
                        activeAccounts[selectedServiceAccountIndex].current.fnoActivationDate && activeAccounts[selectedServiceAccountIndex].current.fnoDeactivationDate
                      "
                    >
                      <v-chip
                        dense
                        color="light-green"
                        class="white--text font-weight-bold"
                        >{{ formatDate(activeAccounts[selectedServiceAccountIndex].current.fnoActivationDate) }}</v-chip
                      >-
                      <v-chip
                        dense
                        v-if="activeAccounts[selectedServiceAccountIndex].current.fnoDeactivationDate"
                        color="red"
                        class="white--text font-weight-bold"
                        >{{ formatDate(activeAccounts[selectedServiceAccountIndex].current.fnoDeactivationDate) }}</v-chip
                      >
                    </v-flex>
                    <v-flex
                      class="grey--text"
                      v-else-if="!activeAccounts[selectedServiceAccountIndex].current.fnoActivationDate"
                    >
                      <v-chip
                        dense
                        color="blue"
                        class="white--text font-weight-bold"
                        >Pending Activation</v-chip
                      >
                    </v-flex>
                  </v-layout>
                  <v-layout justify-left align-center wrap class="text-xs-left">
                    <v-flex xs6 class="subheading grey--text font-weight-bold">
                      <h4 class="subheading grey--text font-weight-bold">
                        Download speed:
                      </h4>
                      <h4 class="subheading grey--text font-weight-bold">
                        Upload speed:
                      </h4>
                      <h4 class="subheading grey--text font-weight-bold">
                        Data:
                      </h4>
                      <h4 class="subheading grey--text font-weight-bold">
                        Contract Term:
                      </h4>
                      <h4 class="subheading grey--text font-weight-bold">
                        Shaped:
                      </h4>
                    </v-flex>
                    <v-flex xs6 class="subheading grey--text font-weight-light">
                      <h4 class="subheading grey--text font-weight-light">
                        {{
                          activeAccounts[selectedServiceAccountIndex].current.packagesIsp.packagesFno.speedProfile
                            .downloadMbps
                        }}
                        Mbps
                      </h4>
                      <h4 class="subheading grey--text font-weight-light">
                        {{
                          activeAccounts[selectedServiceAccountIndex].current.packagesIsp.packagesFno.speedProfile
                            .uploadMbps
                        }}
                        Mbps
                      </h4>
                      <h4
                        class="subheading grey--text font-weight-light"
                        v-if="activeAccounts[selectedServiceAccountIndex].current.packagesIsp.isCapped"
                      >
                        Capped ({{
                          activeAccounts[selectedServiceAccountIndex].current.packagesIsp.cappedAmountGb
                        }}Gb)
                      </h4>
                      <h4
                        class="subheading grey--text font-weight-light"
                        v-else
                      >
                        Uncapped
                      </h4>
                      <h4 class="subheading grey--text font-weight-light">
                        {{ activeAccounts[selectedServiceAccountIndex].current.packagesIsp.term }}
                      </h4>
                      <h4
                        class="subheading grey--text font-weight-light"
                        v-if="activeAccounts[selectedServiceAccountIndex].current.packagesIsp.isShaped"
                      >
                        Yes
                      </h4>
                      <h4
                        class="subheading grey--text font-weight-light"
                        v-else
                      >
                        No
                      </h4>
                    </v-flex>
                  </v-layout>

                  <v-layout wrap>
                    <v-flex
                      xs6
                      class="text-xs-left subheading grey--text font-weight-bold"
                    >
                      <!-- <h4>ISP Once-off Price:</h4> -->
                      <h4>Monthly Price:</h4>
                    </v-flex>
                    <v-flex xs6 class="text-xs-left grey--text font-weight-light">
                      <!-- <h4 class="grey--text font-weight-light">
                        {{
                          activeAccounts[selectedServiceAccountIndex].current.packagesIsp.onceOffPriceVatInc
                            | currency
                        }}
                      </h4> -->
                      <h4 class="grey--text font-weight-light">
                        {{
                          activeAccounts[selectedServiceAccountIndex].current.packagesIsp.recurringPriceVatInc
                            | currency
                        }}
                      </h4>
                    </v-flex>
                  </v-layout>
                </v-card>
                <v-card flat v-show="activeAccounts[selectedServiceAccountIndex].historyTab">
                  <v-layout v-if="activeAccounts[selectedServiceAccountIndex].history&&activeAccounts[selectedServiceAccountIndex].pages" wrap justify-center>
                   
               <v-layout align-center>
                  <v-flex xs1>
                 <v-icon @click="setHistoryBack(activeAccounts[selectedServiceAccountIndex])" v-if="activeAccounts[selectedServiceAccountIndex].count>0">keyboard_arrow_left</v-icon>  

                  </v-flex>
                      <v-flex xs10>
                      <v-layout>
                        <v-flex
                          class="text-xs-center grey--text"
                          v-if="
                            activeAccounts[selectedServiceAccountIndex].pages.fnoActivationDate && !activeAccounts[selectedServiceAccountIndex].pages.fnoDeactivationDate
                          "
                        >
                          <v-chip
                            dense
                            color="light-green"
                            class="white--text font-weight-bold"
                            >{{ formatDate(activeAccounts[selectedServiceAccountIndex].pages.fnoActivationDate) }}</v-chip
                          >-
                          <v-chip
                            color="blue"
                            dense
                            class="white--text font-weight-bold"
                            >Present</v-chip
                          >
                        </v-flex>
                        <v-flex
                          class="text-xs-center grey--text"
                          v-else-if="
                            activeAccounts[selectedServiceAccountIndex].pages.fnoActivationDate && activeAccounts[selectedServiceAccountIndex].pages.fnoDeactivationDate
                          "
                        >
                          <v-chip
                            dense
                            color="light-green"
                            class="white--text font-weight-bold"
                            >{{ formatDate(activeAccounts[selectedServiceAccountIndex].pages.fnoActivationDate) }}</v-chip
                          >-
                          <v-chip
                            dense
                            v-if="account.pages.fnoDeactivationDate"
                            color="red"
                            class="white--text font-weight-bold"
                            >{{ formatDate(activeAccounts[selectedServiceAccountIndex].pages.fnoDeactivationDate) }}</v-chip
                          >
                        </v-flex>
                        <v-flex
                          class="grey--text"
                          v-else-if="!activeAccounts[selectedServiceAccountIndex].pages.fnoActivationDate"
                        >
                          <v-chip
                            dense
                            color="blue"
                            class="white--text font-weight-bold"
                            >Pending Activation</v-chip
                          >
                        </v-flex>
                      </v-layout>
                      <v-layout>
                        <v-flex
                          xs6
                          class="subheading grey--text font-weight-bold"
                        >
                          <h4 class="subheading grey--text font-weight-bold">
                            Download speed:
                          </h4>
                          <h4 class="subheading grey--text font-weight-bold">
                            Upload speed:
                          </h4>
                          <h4 class="subheading grey--text font-weight-bold">
                            Data:
                          </h4>
                          <h4 class="subheading grey--text font-weight-bold">
                            Contract Term:
                          </h4>
                          <h4 class="subheading grey--text font-weight-bold">
                            Shaped:
                          </h4>
                        </v-flex>
                        <v-flex
                          xs6
                          class="subheading grey--text font-weight-light"
                        >
                          <h4 class="subheading grey--text font-weight-light">
                            {{
                              activeAccounts[selectedServiceAccountIndex].pages.packagesIsp.packagesFno.speedProfile
                                .downloadMbps
                            }}
                            Mbps
                          </h4>
                          <h4 class="subheading grey--text font-weight-light">
                            {{
                             activeAccounts[selectedServiceAccountIndex].pages.packagesIsp.packagesFno.speedProfile
                                .uploadMbps
                            }}
                            Mbps
                          </h4>
                          <h4
                            class="subheading grey--text font-weight-light"
                            v-if="activeAccounts[selectedServiceAccountIndex].pages.packagesIsp.isCapped"
                          >
                            Capped ({{ activeAccounts[selectedServiceAccountIndex].pages.packagesIsp.cappedAmountGb }}Gb)
                          </h4>
                          <h4
                            class="subheading grey--text font-weight-light"
                            v-else
                          >
                            Uncapped
                          </h4>
                          <h4 class="subheading grey--text font-weight-light">
                            {{ activeAccounts[selectedServiceAccountIndex].pages.packagesIsp.term }}
                          </h4>
                          <h4
                            class="subheading grey--text font-weight-light"
                            v-if="activeAccounts[selectedServiceAccountIndex].pages.packagesIsp.isShaped"
                          >
                            Yes
                          </h4>
                          <h4
                            class="subheading grey--text font-weight-light"
                            v-else
                          >
                            No
                          </h4>
                        </v-flex>
                      </v-layout>

                      <v-layout wrap>
                        <v-flex
                          xs6
                          class="text-xs-left subheading grey--text font-weight-bold"
                        >
                          <h4>ISP Once-off Price:</h4>
                          <h4>ISP Monthly Price:</h4>
                        </v-flex>
                        <v-flex xs6 class="grey--text font-weight-light">
                          <h4 class="grey--text font-weight-light">
                            {{ activeAccounts[selectedServiceAccountIndex].pages.packagesIsp.onceOffPriceVatInc | currency }}
                          </h4>
                          <h4 class="grey--text font-weight-light">
                            {{
                              activeAccounts[selectedServiceAccountIndex].pages.packagesIsp.recurringPriceVatInc | currency
                            }}
                          </h4>
                        </v-flex>
                      </v-layout>
                    </v-flex>

                     <v-flex xs1>
                        <v-icon @click="setHistoryNext(activeAccounts[selectedServiceAccountIndex])"  v-if="activeAccounts[selectedServiceAccountIndex].count<activeAccounts[selectedServiceAccountIndex].history.length-1">keyboard_arrow_right</v-icon> 
                     </v-flex>
                      
                      </v-layout>
                   
                  </v-layout>

                </v-card>
              </v-card>
                        </v-card>
              </v-flex>
              <v-flex xs1><v-icon v-if="selectedServiceAccountIndex<(activeAccounts.length-1)" @click="selectedServiceAccountIndex++">chevron_right</v-icon><v-icon v-else disabled>chevron_right</v-icon></v-flex>

               
                        
            </v-layout>
                        <span v-else class="grey--text">No active accounts.</span>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex
        v-if="pendingRequests.length > 0"
        :key="keyPending"
        xs12
        sm12
        md4
        lg4
        xl4
        my-1
      >
        <h2 class="dark-grey--text ma-2 pa-2">Pending Requests</h2>

        <v-layout
          wrap
          justify-center
          class="scroll-y ma-2 pa-2"
          style="max-height: 450px"
        >
          <v-flex
            xs12
            sm12
            md12
            v-for="pending in pendingRequests"
            :key="pending.id"
          >
            <v-card min-width="250px" class="ma-2 pa-2" hover>
              <v-tile>
                <v-layout align-center wrap>
                  <v-flex xs12>
                    <h3
                      v-if="
                        pendingRequests &&
                        pending.requestType.includes('Upgrade')
                      "
                      class="green--text"
                    >
                      {{ pending.requestType }}
                    </h3>
                    <h3
                      v-else-if="
                        pendingRequests &&
                        pending.requestType.includes('Downgrade')
                      "
                      class="orange--text"
                    >
                      {{ pending.requestType }}
                    </h3>
                    <h3 v-else class="red--text">
                      {{ pending.requestType }}
                    </h3>
                  </v-flex>
                  <v-flex>
                    <v-tile-title>
                      <div
                        v-if="
                          pendingRequests &&
                          (pending.requestType.includes('Upgrade') ||
                            pending.requestType.includes('Downgrade')) &&
                          pending.fromIspPackageId &&
                          pending.toIspPackageId
                        "
                      >
                        <h4 class="grey--text">
                          {{ pending.fromIspPackage.name }}
                          to
                          {{ pending.toIspPackage.name }}
                        </h4>
                        <h4 class="grey--text">
                          From:
                          <v-icon color="light-green">arrow_drop_down</v-icon>
                          {{
                            pending.fromIspPackage.packagesFno.speedProfile
                              .downloadMbps
                          }}
                          <v-icon color="red">arrow_drop_up</v-icon>
                          {{
                            pending.toIspPackage.packagesFno.speedProfile
                              .uploadMbps
                          }}
                        </h4>
                        <h4 class="grey--text">
                          To:
                          <v-icon color="light-green">arrow_drop_down</v-icon>
                          {{
                            pending.fromIspPackage.packagesFno.speedProfile
                              .downloadMbps
                          }}
                          <v-icon color="red">arrow_drop_up</v-icon>
                          {{
                            pending.toIspPackage.packagesFno.speedProfile
                              .uploadMbps
                          }}
                        </h4>
                      </div>
                      <div
                        v-if="
                          pendingRequests &&
                          pending.requestType.includes('Terminate')
                        "
                      >
                        <h4 class="grey--text">
                          {{ pending.serviceAccount.packagesIsp.name }}
                        </h4>
                      </div>
                    </v-tile-title>
                    <v-tile-subtitle>
                      <h4 class="grey--text font-weight-light">
                        Submitted: {{ formatDate(pending.createdAt) }}
                      </h4>
                    </v-tile-subtitle>
                  </v-flex>
                </v-layout>
              </v-tile>
            </v-card>
          </v-flex>

          <v-flex v-if="pendingRequests.length == 0">
            <v-layout align-center justify-center>
              <h3 class="grey--text font-weight-light">No Pending Requests.</h3>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-dialog persistent v-model="resetPasswordDialog" max-width="500px">
      <v-card>
        <v-toolbar color="primary"
          ><h3 style="text-align: left" class="headline white--text">
            Reset Password
          </h3>
          <v-spacer></v-spacer>
          <v-btn
            class="white--text"
            depressed
            flat
            v-if="
              newPassword !== '' &&
              currentPassword !== '' &&
              confirmPassword !== ''
            "
            @click="savePassword()"
            >Save</v-btn
          >
          <v-btn color="primary" v-else flat disabled>Save</v-btn>
          <v-icon @click="resetPasswordDialog = false" class="white--text"
            >close</v-icon
          >
        </v-toolbar>

        <v-card-text>
          <v-container>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field
                  prepend-icon="vpn_key"
                  color="primary"
                  :append-icon="show1 ? 'visibility' : 'visibility_off'"
                  :type="show1 ? 'text' : 'password'"
                  @click:append="show1 = !show1"
                  persistent-hint
                  hint="Current password does not match"
                  v-if="currentPasswordCorrect === false"
                  v-model="currentPassword"
                  label="Current Password"
                ></v-text-field>
                <v-text-field
                  prepend-icon="vpn_key"
                  color="primary"
                  :append-icon="show1 ? 'visibility' : 'visibility_off'"
                  :type="show1 ? 'text' : 'password'"
                  @click:append="show1 = !show1"
                  v-else
                  v-model="currentPassword"
                  label="Current Password"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field
                  prepend-icon="vpn_key"
                  color="primary"
                  :append-icon="show2 ? 'visibility' : 'visibility_off'"
                  :type="show2 ? 'text' : 'password'"
                  @click:append="show2 = !show2"
                  v-model="newPassword"
                  label="New Password"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field
                  prepend-icon="vpn_key"
                  color="primary"
                  :append-icon="show3 ? 'visibility' : 'visibility_off'"
                  :type="show3 ? 'text' : 'password'"
                  @click:append="show3 = !show3"
                  persistent-hint
                  hint="New password does not match"
                  v-if="newPasswordsMatch === false"
                  v-model="confirmPassword"
                  label="Confirm Password"
                ></v-text-field>

                <v-text-field
                  v-else
                  prepend-icon="vpn_key"
                  color="primary"
                  :append-icon="show3 ? 'visibility' : 'visibility_off'"
                  :type="show3 ? 'text' : 'password'"
                  @click:append="show3 = !show3"
                  v-model="confirmPassword"
                  label="Confirm Password"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="editingContact" max-width="750px">
      <v-card flat color="white">
        <v-toolbar color="primary">
          <h3 class="title white--text">Contact Details</h3>
          <v-spacer></v-spacer>
          <v-btn
                flat
                color="white"
                v-if="editingContact"
                @click="editContactInfo()"
                >Save
              </v-btn>
          <v-btn color="white" flat @click="editingContact = false">X</v-btn>
        </v-toolbar>
        <v-card-text>
                <v-layout justify-left align-center wrap class="text-xs-left">
                  <v-flex xs6 mx-1>
                    <h2 class="subheading grey--text font-weight-bold">
                      Name:
                    </h2>
                  </v-flex>
                  <v-flex xs4 mx-1>
                    <v-text-field v-model="contact.name"></v-text-field>
                  </v-flex>
                  <v-flex xs6 mx-1>
                    <h2 class="subheading grey--text font-weight-bold">
                      Surname:
                    </h2>
                  </v-flex>
                  <v-flex xs4 mx-1>
                    <v-text-field v-model="contact.surname"></v-text-field>
                  </v-flex>
                  <v-flex xs6 mx-1>
                    <h2 class="subheading grey--text font-weight-bold">
                      ID Number:
                    </h2>
                  </v-flex>
                  <v-flex xs4 mx-1>
                    <v-text-field v-model="contact.idNumber"></v-text-field>
                  </v-flex>
                  <v-flex xs6 mx-1>
                    <h2 class="subheading grey--text font-weight-bold">
                      Mobile Number:
                    </h2>
                  </v-flex>
                  <v-flex xs4 mx-1>
                    <v-text-field v-model="contact.mobileNumber"></v-text-field>
                  </v-flex>
                  <v-flex xs6 mx-1>
                    <h2 class="subheading grey--text font-weight-bold">
                      Telephone Number:
                    </h2>
                  </v-flex>
                  <v-flex xs4 mx-1>
                    <v-text-field
                      v-model="contact.telephoneNumber"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 mx-1>
                    <h2 class="subheading grey--text font-weight-bold">
                      Email Address:
                    </h2>
                  </v-flex>
                  <v-flex xs4 mx-1>
                    <v-text-field v-model="contact.emailAddress"></v-text-field>
                  </v-flex>
                  </v-layout>
              
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="agreementModal" width="750px" persistent>
      <v-card flat color="white" v-if="agreement">
        <v-toolbar flat color="primary">
          <h3 class="title white--text">{{ agreement.name }}</h3>
          <v-spacer></v-spacer>
          <v-btn
            flat
            color="white"
            @click="(agreement = null), (agreementModal = false)"
            >X</v-btn
          >
        </v-toolbar>
        <v-card-text style="overflow-y: auto; max-height: 600px">
          <vue-simple-markdown
            v-if="agreement.content"
            class="text-xs-left"
            :key="agreement.content"
            :image="true"
            :source="agreement.content"
          ></vue-simple-markdown>
        </v-card-text>
        <v-card-actions>
          <v-layout justify-center>
            <v-btn
            v-if="!submittingAgreement"
              round
              color="primary"
              class="white--text"
              @click="acceptAgreement(agreement)"
              >I Accept</v-btn
            >
            <v-btn v-else-if="submittingAgreement" round disabled>
                          <span>Submitting </span>  <v-progress-circular
                          size="20"
                          indeterminate
                          color="white"
                        ></v-progress-circular></v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="quoteModal" max-width="1000px" min-width="300px">
       <sagequotemodal  :quote="quoteItem" :taxtypes="taxTypes"
       :type="'read'"
       @closeModal="quoteItem={}, quoteModal=false"
       @acceptPay="acceptQuote($event)"
       ></sagequotemodal>
    </v-dialog>

    <v-dialog persistent v-model="upgradePackagesDialog" max-width="750px">
      <v-card flat color="white">
        <v-toolbar color="primary"><h1 class="headline white--text">Upgrade</h1>
        <!-- <h1 v-if="selectedPackage" class="pl-2 headline white--text"> to {{selectedPackage.name}}</h1> -->
              <v-spacer></v-spacer>

               <v-btn class="white--text" depressed flat  v-if="selectedPackage&&preferredDate&&chooseDate" @click="saveRequest(selectedPackage, 'Upgrade')">Submit</v-btn>               
               <v-btn  color="primary" v-else-if="chooseDate" flat disabled>Submit</v-btn>

               <v-btn  class="white--text" v-if="choosePackages" @click="choosePackages=false; chooseDate=true" flat>Next</v-btn>
              <v-icon @click="(upgradePackagesDialog = false)" class="white--text" >close</v-icon>
              </v-toolbar>
        <v-card-text v-show="choosePackages">
         
            <v-layout class="scroll-y ma-2 pa-2" style="max-height:450px" v-if="upgradePackages" wrap >
              <v-flex
                xs12 sm12 md6 lg4 xl4
                v-for="upgrade in upgradePackages"
                :key="upgrade.id"
                text-xs-left
              >
                <div name="packageCard" :id="upgrade.id" class="elevation-5 ma-2 pa-2" style="text-align:center; padding:0px; cursor:pointer;"  :class= "{'greenBorder': (upgrade.id==keepColorId)}" @click="selectPackage(upgrade)" hover>
                  <v-layout>
                    <v-avatar class="white">
                      <v-img
                        contain
                        alt="Avatar"
                        :key="upgrade.customerOrganisation.logo"
                        :src="upgrade.customerOrganisation.logo"
                      />
                    </v-avatar>
                    <v-spacer></v-spacer>
                    <h3 class="grey--text justify-center">
                      {{ upgrade.name }}
                    </h3>
                  </v-layout>
                  <v-layout justify-center>
                    <span class="grey--text" v-if="upgrade.isCapped">Capped</span>
                    <span class="grey--text" v-if="!upgrade.isCapped">Uncapped</span>/
                    <span class="grey--text" v-if="upgrade.isShaped">Shaped</span>
                    <span class="grey--text" v-if="!upgrade.isShaped">Unshaped</span>
                  </v-layout>
                    <v-layout justify-center>
                    <h3 text-center class="grey--text" text-wrap>
                      {{ upgrade.term }}
                    </h3>
                    </v-layout>
                      <v-layout justify-center>
                    <v-chip v-if="upgrade.isPromo" color="success"
                      >Promo Offer</v-chip
                    >
                  </v-layout>
                  <v-layout justify-center>
                      <v-chip text-center>
                        <span style="color: grey" text-wrap
                          >{{
                            upgrade.recurringPriceVatInc | currency
                          }}
                          pm</span
                        >
                      </v-chip>
                  </v-layout>
                  <v-layout justify-center>
                      <v-chip
                        color="gluePrimary"
                        v-if="upgrade.onceOffPriceVatInc > 0"
                      >
                        <span class="subtitle" style="color: grey"
                          >{{ upgrade.onceOffPriceVatInc | currency }} Setup
                          Fee</span
                        >
                      </v-chip>
                  </v-layout>
                  <v-layout justify-center>
                      <v-chip
                        color="gluePrimary"
                        v-if="upgrade.onceOffPriceVatInc == 0"
                      >
                        <span class="subtitle" style="color: grey"
                          >Free Setup</span
                        >
                      </v-chip>
                  </v-layout>
                </div>
              </v-flex>
            </v-layout>
        </v-card-text>
         <v-card-text v-show="chooseDate">
          <v-flex xs12>
            <v-menu>
              <v-text-field
                :value="formatDate(this.preferredDate)"
                slot="activator"
                label="Preferred Start Date"
                prepend-icon="date_range"
              ></v-text-field>
              <v-date-picker v-model="preferredDate"></v-date-picker>
            </v-menu>
          </v-flex>
         </v-card-text>
          <v-card-actions>
                   <v-btn color="primary" round class="white--text" v-if="chooseDate" @click="choosePackages=true; chooseDate=false" >Back</v-btn>

                    </v-card-actions>
      </v-card>
    </v-dialog>

      <v-dialog persistent v-model="downgradePackagesDialog" max-width="750px">
      <v-card flat color="white">
         <v-toolbar color="primary"><h1 class="headline white--text">Downgrade</h1>
         <!-- <h1 v-if="selectedPackage" class="pl-2 headline white--text"> to {{selectedPackage.name}}</h1> -->
              <v-spacer></v-spacer>

                <v-btn class="white--text" depressed flat  v-if="selectedPackage&&preferredDate&&chooseDate" @click="saveRequest(selectedPackage, 'Downgrade')">Submit</v-btn>               
               <v-btn  color="primary" v-else-if="chooseDate" flat disabled>Submit</v-btn>

               <v-btn class="white--text" v-if="choosePackages" @click="choosePackages=false; chooseDate=true" flat>Next</v-btn>
              <v-icon @click="(downgradePackagesDialog = false)" class="white--text" >close</v-icon>
              </v-toolbar>
        <v-card-text v-show="choosePackages">
         
            <v-layout class="scroll-y ma-2 pa-2" style="max-height:450px" v-if="downgradePackages" wrap >
              <v-flex
                xs12 sm12 md6 lg4 xl4
                v-for="downgrade in downgradePackages"
                :key="downgrade.id"
                text-xs-left
              >
                <div name="packageCard" :id="downgrade.id" class="elevation-5 ma-2 pa-2" style="text-align:center; padding:0px; cursor:pointer;"  :class= "{'greenBorder': (downgrade.id==keepColorId)}" @click="selectPackage(downgrade)" hover>
                  <v-layout>
                    <v-avatar class="white">
                      <v-img
                        contain
                        alt="Avatar"
                        :key="downgrade.customerOrganisation.logo"
                        :src="downgrade.customerOrganisation.logo"
                      />
                    </v-avatar>
                    <v-spacer></v-spacer>
                    <h3 class="grey--text justify-center">
                      {{ downgrade.name }}
                    </h3>
                  </v-layout>
                  <v-layout justify-center>
                    <span class="grey--text" v-if="downgrade.isCapped">Capped</span>
                    <span class="grey--text" v-if="!downgrade.isCapped">Uncapped</span>/
                    <span class="grey--text" v-if="downgrade.isShaped">Shaped</span>
                    <span class="grey--text" v-if="!downgrade.isShaped">Unshaped</span>
                  </v-layout>
                    <v-layout justify-center>
                    <h3 text-center class="grey--text" text-wrap>
                      {{ downgrade.term }}
                    </h3>
                    </v-layout>
                      <v-layout justify-center>
                    <v-chip v-if="downgrade.isPromo" color="success"
                      >Promo Offer</v-chip
                    >
                  </v-layout>
                  <v-layout justify-center>
                      <v-chip text-center>
                        <span style="color: grey" text-wrap
                          >{{
                            downgrade.recurringPriceVatInc | currency
                          }}
                          pm</span
                        >
                      </v-chip>
                  </v-layout>
                  <v-layout justify-center>
                      <v-chip
                        color="gluePrimary"
                        v-if="downgrade.onceOffPriceVatInc > 0"
                      >
                        <span class="subtitle" style="color: grey"
                          >{{ downgrade.onceOffPriceVatInc | currency }} Setup
                          Fee</span
                        >
                      </v-chip>
                  </v-layout>
                  <v-layout justify-center>
                      <v-chip
                        color="gluePrimary"
                        v-if="downgrade.onceOffPriceVatInc == 0"
                      >
                        <span class="subtitle" style="color: grey"
                          >Free Setup</span
                        >
                      </v-chip>
                  </v-layout>
                </div>
              </v-flex>
            </v-layout>
        </v-card-text>
        
         <v-card-text v-show="chooseDate">
          <v-flex xs12>
            <v-menu>
              <v-text-field
                :value="formatDate(this.preferredDate)"
                slot="activator"
                label="Preferred Start Date"
                prepend-icon="date_range"
              ></v-text-field>
              <v-date-picker v-model="preferredDate"></v-date-picker>
            </v-menu>
          </v-flex>
         </v-card-text>
          <v-card-actions>
                   <v-btn color="primary" round class="white--text" v-if="chooseDate" @click="choosePackages=true; chooseDate=false" >Back</v-btn>

                    </v-card-actions>
      </v-card>
    </v-dialog>

  <v-dialog persistent v-model="terminatePackagesDialog" max-width="500px">
      <v-card flat color="white">
         <v-toolbar color="primary"><h1 class="headline white--text">Termination</h1>
              <v-spacer></v-spacer>
               <v-btn class="white--text" depressed flat  v-if="preferredDate" @click="saveTermination()">Save</v-btn>               
               <v-btn  color="primary" v-else flat disabled>Save</v-btn>
               <v-icon @click="(terminatePackagesDialog = false)" class="white--text" >close</v-icon>
              </v-toolbar>
        <v-card-text>
          <v-layout>
            <v-flex xs12>
            <v-menu>
              <v-text-field
                :value="formatDate(this.preferredDate)"
                slot="activator"
                label="Preferred Termination Date"
                prepend-icon="date_range"
              ></v-text-field>
              <v-date-picker v-model="preferredDate"></v-date-picker>
            </v-menu>
            </v-flex>
          </v-layout>
         
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Api from "@/services/Api";
import dateformat from "dateformat";
import UserServices from '@/components/UserPortalServices.vue'
import SageOneQuoteModal from '@/components/SageQuoteModal.vue'
export default {
  components: {
    userservices: UserServices,
    sagequotemodal: SageOneQuoteModal
  },
  data() {
    return {
      agreementModal: false,
      agreement: null,
      billingTab: 'invoices',
      documents: [],
      keyPending: 0,
      transactions: [],
      invoices: [],
      quotes: [],
      pendingRequests: [],
      show1: false,
      show2: false,
      show3: false,
      newPasswordsMatch: null,
      currentPasswordCorrect: null,
      currentPassword: "",
      newPassword: "",
      confirmPassword: "",
      resetPasswordDialog: false,
      key: 0,
      quoteItem: {},
      quoteModal: false,
      editingContact: false,
      activeAccounts: [],
      // activeAccounts: null,
      selectedServiceAccountIndex: 0,
      changeRequests: [],
      allLocations: [],
      loaded: false,
      snackbar: false,
      errorSnackbar: false,
      submittingAgreement: false,
      text: "",
      y: "top",
      contact: [],
      initial: [],
      taxTypes: [],
      contactChangedObj: {},
      serviceAccounts: [],
      tickets: [],
      choosePackages:false,
          chooseDate:false,
          keepColorId:null,
          terminatePackagesDialog:false,
          selectedPackage:null,
          serviceAccount:{},
          downgradePackagesDialog:false,
          upgradePackagesDialog:false,      
          downgradePackages:[],
          upgradePackages:[],
          allPackages:[],
          preferredDate: null,
      transactionHeaders: [
        {
          text: "Document No.",
          align: "center",
          value: "DocumentNumber"
        },
        {
          text: "Date",
          align: "center",
          value: "Date"
        },
        {
          text: "Amount",
          align: "center",
          value: "Total"
        }
        ,
        {
          text: "Status",
          align: "center",
          value: "AmountDue"
        }
      ],
      quoteHeaders: [
        {
          text: "Action",
          align: "center",
          sortable: false
        },
        {
          text: "Document No.",
          align: "center",
          value: "document"
        },
        {
          text: "Date",
          align: "center",
          value: "date"
        },
        {
          text: "Expires",
          align: "center",
          value: "expires"
        }
        ,
        {
          text: "Status",
          align: "center",
          value: "isAccepted"
        }
      ]
    };
  },
  created() {
    this.loaded = false;
    this.getServiceAccounts();
    this.getChangeRequests();
    this.getPendingRequests();
    this.fetchLocations();
    this.fetchContactInfo();
    this.fetchInitialContactInfo();
    this.fetchDocuments();
    this.fetchTransactions();
    this.fetchQuotes()
    this.fetchSageTaxTypes()
    // this.getServiceAccounts()

  },
  watch: {},
  methods: {
    async processRequest(type){
     this.clearPackageSelection();
     
     this.preferredDate=null
     this.selectedPackage = null
     Api().get('/customer/availablePackages/' + this.activeAccounts[this.selectedServiceAccountIndex].current.location.locationNetworkId+'/'+this.activeAccounts[this.selectedServiceAccountIndex].current.customerOrganisationId).then(async response=>{
      // this.allPackages = await response.data.sort((a,b) => (a.packagesFno.speedProfile.downloadMbps > b.packagesFno.speedProfile.downloadMbps) ? 1 : ((b.packagesFno.speedProfile.downloadMbps > a.packagesFno.speedProfile.downloadMbps) ? -1 : 0))
    this.allPackages = response.data.activePackages
    console.log(this.allPackages)
    this.allPackages.map((x) => {
            x.customerOrganisation = response.data.organisations.find(y=>y.id==x.customerOrganisationId)
          });
    if(type =='Upgrade'){
      this.upgradePackagesDialog=true
      this.upgradePackages = await this.allPackages.filter(x=>
        x.customerOrganisationId === this.activeAccounts[this.selectedServiceAccountIndex].current.packagesIsp.customerOrganisationId &&
        (x.packagesFno.speedProfile.downloadMbps >this.activeAccounts[this.selectedServiceAccountIndex].current.packagesIsp.packagesFno.speedProfile.downloadMbps ||
          (x.packagesFno.speedProfile.downloadMbps >= this.activeAccounts[this.selectedServiceAccountIndex].current.packagesIsp.packagesFno.speedProfile.downloadMbps &&
            x.packagesFno.speedProfile.uploadMbps > this.activeAccounts[this.selectedServiceAccountIndex].current.packagesIsp.packagesFno.speedProfile.uploadMbps)
        ))
        this.serviceAccount=this.activeAccounts[this.selectedServiceAccountIndex].current
       
    } else if(type =='Downgrade'){
      this.downgradePackagesDialog=true
      this.downgradePackages = await this.allPackages.filter(x=>
        x.customerOrganisationId === this.activeAccounts[this.selectedServiceAccountIndex].current.packagesIsp.customerOrganisationId &&
        (x.packagesFno.speedProfile.downloadMbps < this.activeAccounts[this.selectedServiceAccountIndex].current.packagesIsp.packagesFno.speedProfile.downloadMbps ||
          (x.packagesFno.speedProfile.downloadMbps <= this.activeAccounts[this.selectedServiceAccountIndex].current.packagesIsp.packagesFno.speedProfile.downloadMbps &&
            x.packagesFno.speedProfile.uploadMbps < this.activeAccounts[this.selectedServiceAccountIndex].current.packagesIsp.packagesFno.speedProfile.uploadMbps)
        ))
        this.serviceAccount=this.activeAccounts[this.selectedServiceAccountIndex].current
        
    }
    this.choosePackages=true
     this.chooseDate=false
   })
   },
   clearPackageSelection() {
                let elements = document.getElementsByName("packageCard")
                
                for (let i = 0; i < elements.length; i++) {
                    elements[i].style.border = "none";
                    elements[i].style.backgroundColor = "white";
                }
      
            },
    selectPackage(pack){
                   this.clearPackageSelection();
                   if(this.selectedPackage===null){
                 this.selectedPackage = pack
                        this.keepColorId = pack.id
      
                        document.getElementById(pack.id).style.backgroundColor = "#e6e6e6"
                        document.getElementById(pack.id).style.border = "1px solid #99cc33"
                   }else{
                  if (pack.id != this.selectedPackage.id) {
                        this.selectedPackage = pack
                        this.keepColorId = pack.id
      
                        document.getElementById(pack.id).style.backgroundColor = "#e6e6e6"
                        document.getElementById(pack.id).style.border = "1px solid #99cc33"
                    }
                    else if (pack.id == this.selectedPackage.id) {
                        this.selectedPackage = null;
                        this.keepColorId=null
                    }
                   }
                  

    },
    async saveRequest(pack, type){    
      let obj = {
        contactId: this.$store.state.user.id,
        ispName: this.serviceAccount.packagesIsp.customerOrganisation.name,
        requestType: type,
        requestedDate: this.preferredDate,
        fromIspPackageId: this.serviceAccount.packagesIspId,
        toIspPackageId: pack.id,
        customerOrganisationId: this.serviceAccount.packagesIsp.customerOrganisationId,
        serviceAccountId: this.serviceAccount.id
      }
      Api().post('/customer/changeRequest', obj).then(response=>{
         this.downgradePackagesDialog=false
         this.upgradePackagesDialog=false
           this.choosePackages=false
           this.chooseDate=false
      })
  },
     setHistoryBack(account){
      for(let i=0; i<this.activeAccounts.length; i++){
        if(this.activeAccounts[i].current.id===account.current.id){
         this.activeAccounts[i].count= this.activeAccounts[i].count-1
         this.activeAccounts[i].pages = this.activeAccounts[i].history[this.activeAccounts[i].count]
        }
      
      }
    },
    setHistoryNext(account){
      for(let i=0; i<this.activeAccounts.length; i++){
        if(this.activeAccounts[i].current.id===account.current.id){
         this.activeAccounts[i].count= this.activeAccounts[i].count+1
         this.activeAccounts[i].pages = this.activeAccounts[i].history[this.activeAccounts[i].count]
        }
      
      }
    },
    async acceptQuote(data){
      console.log(data)
      await Api().put('/customerBilling/'+this.quoteItem.id, {
        isAccepted: true
      })
      let obj = data
      delete obj.DocumentNumber
      delete obj.id
      delete obj.ExpiryDate
      await obj.Lines.map(x=>
      delete x.ID)
      let today = new Date()
      obj.Date = [today.getFullYear(), (today.getMonth()+1)<10?'0'+(today.getMonth()+1).toString():today.getMonth()+1, today.getDate()<10?'0'+today.getDate().toString():today.getDate()].join('-')
      obj.DueDate = [today.getFullYear(), (today.getMonth()+1)<10?'0'+(today.getMonth()+1).toString():today.getMonth()+1, today.getDate()<10?'0'+today.getDate().toString():today.getDate()].join('-')
      obj.contactId = this.$store.state.user.id
      obj.applicationId= this.quoteItem.applicationId
      obj.serviceAccountId= this.quoteItem.serviceAccountId
      await Api().post('/sageOne/createInvoice', obj).then(response=>{
        console.log(response.data)
        if(response.data.secretKey){
          let payNowFormData = {
                M1: response.data.secretKey,
                M2: "24ade73c-98cf-47b3-99be-cc7b867b3080",
                p2: response.data.DocumentNumber,
                p3: "Order: " + this.quoteItem.applicationId,
                p4: response.data.Total,
                Budget: "N",
                m4: this.quoteItem.applicationId,
                // ?'applicationId='+this.quoteItem.applicationId:this.quoteItem.serviceAccountId?'serviceAccountId='+response.data.serviceAccountId:null,
                m5: response.data.ID,
                m6: response.data.CustomerId,
                m9: this.$store.state.user.emailAddress,
                m11: this.contact.mobileNumber,
                m10: response.data.DocumentNumber,
                m14: 0,
              };
              document.body.innerHTML += `
              <form id="payNowForm" method="POST" action="https://paynow.netcash.co.za/site/paynow.aspx" target="_top"> <!---Form POST **--->
  <input type="text" name="M1" value="${payNowFormData.M1}">  <!--- YOUR PAY NOW SERVICE KEY GOES IN HERE --->
  <input type="text" name="M2" value="${payNowFormData.M2}">  <!--- SOFTWARE VENDOR KEY GOES IN HERE --->
  <input type="text" name="p2" value="${payNowFormData.p2}">                                <!---Unique ID for this / each transaction--->
  <input type="text" name="p3"  value="${payNowFormData.p3}">                    <!---Description of goods being purchased--->
  <input type="text" name="p4" value="${payNowFormData.p4}">                                  <!---Amount to be settled / paid--->
  <input type="text" name="Budget" value="${payNowFormData.Budget}">                                 <!---Compulsory should be Y--->
  <input type="text" name="m4" value="orderId=${payNowFormData.m4}"> 
  <input type="text" name="m5" value="${payNowFormData.m5}">                               <!---This is an extra field ***--->
  <input type="text" name="m6" value="${payNowFormData.m6}">                               <!---This is an extra field ***--->
  <input type="text" name="m9" value="${payNowFormData.m9}">                     <!---Card holders email address--->
  <input type="text" name="m11" value="${payNowFormData.m11}">                           <!---Card holders mobile number--->
  <input type="text" name="m10" value="${payNowFormData.m4}">             <!---Dataset used by shopping carts i.e. OSCommerce--->
  <input type="text" name="m14" value="${payNowFormData.m14}">                                    <!---Request credit card subscription token 0 = no | 1 = yes--->
  
</form>
              `;
              
              document.getElementById("payNowForm").submit();
        }
        
      })
    },
    async fetchSageTaxTypes(){
      await Api().get('/sageOne/taxTypes').then(res=>{
        this.taxTypes = res.data.Results
      })
    },
    async viewQuote(item){
        await Api().get('/sageOne/quote/'+item.accountingId).then(res=>{
        this.quoteItem = res.data
        this.quoteItem.id = item.id
        this.quoteItem.applicationId = item.applicationId
        this.quoteItem.serviceAccountId = item.serviceAccountId
        this.quoteModal = true
      })
      
    },
    async fetchQuotes(){
      Api().get('/customerBilling/contact/'+this.$store.state.user.id).then(res=>{
        this.quotes = res.data
      })
    },
    async fetchTransactions(){
      await Api().get('/sageOne/customer/transactions').then(res=>{
        if(res.data.length>0){
           this.transactions = res.data
           this.invoices = res.data
        }
      })
    },
    async getServiceAccounts() {
      await Api()
        .get(
          "/endUser/serviceAccounts/" +
            this.$store.state.user.id
        )
        .then(response => {
          this.serviceAccounts = response.data;
        });
    },
    viewAgreement(item) {
      console.log(item);
      let result = item.organisationAgreement;
      result.content = result.content.replace(/@firstname/g, this.contact.name);
      result.content = result.content.replace(
        /@lastname/g,
        this.contact.surname
      );
      result.content = result.content.replace(
        /@emailAddress/g,
        this.contact.emailAddress
      );

      result.uploadId = item.id;
      this.agreement = result;
      this.agreementModal = true;
    },
    async acceptAgreement(item) {
      this.submittingAgreement = true
      item.content = item.content.replace(/@timestamp/g, new Date());
      await Api()
        .put("/agreements/accept/" + item.uploadId, item)
        .then((res) => {
          this.submittingAgreement = false
          this.agreementModal = false;
          this.agreement = null;
          this.fetchDocuments();
        });
    },
    viewFile(item) {
      let linkSource = item.url;
      if (item.base64) {
        linkSource = `data:${item.type};base64,${item.base64}`;
      }
      let pdfWindow = window.open("");
      pdfWindow.document.write(
        `<iframe width='100%' height='100%' src='${linkSource}'></iframe>`
      );
    },
    downloadFile(item) {
      const linkSource = `data:${item.type};base64,${item.base64}`;
      const downloadLink = document.createElement("a");
      const fileName = item.name;
      downloadLink.href = linkSource;
      downloadLink.download = fileName;
      downloadLink.click();
    },
    async fetchDocuments() {
      if (this.$store.state.userOrg) {
        await Api()
          .get("/agreements/userPortal")
          .then((res) => {
            this.documents = res.data;
          });
      }
    },
    async selectFile(event, type) {
      await this.uploadFile(event.srcElement.files[0], type);
    },
    async uploadFile(file, type) {
      var reader = await new FileReader();
      await reader.readAsDataURL(file);
      reader.onload = () => {
        this.setResult(reader.result, type);
      };
      reader.onerror = function () {
        console.log("there are some problems");
      };
    },
    setResult(result, type) {
      if (type === "id") {
        this.contact.idDocument = result;
      } else if (type === "fica") {
        this.contact.ficaDocument = result;
      }
    },
    getPendingRequests() {
      Api()
        .get(
          "/userPortal/endCustomerRequests/pending/" + this.$store.state.user.id
        )
        .then((response) => {
          this.pendingRequests = response.data;
          this.keyPending++;
        });
    },
    resetDialogFields() {
      this.resetPasswordDialog = true;
      (this.newPasswordsMatch = null),
        (this.currentPasswordCorrect = null),
        (this.currentPassword = ""),
        (this.newPassword = ""),
        (this.confirmPassword = "");
    },
    savePassword() {
      Api()
        .post("/matchCurrentPassword", {
          emailAddress: this.$store.state.user.emailAddress,
          password: this.currentPassword,
        })
        .then((response) => {
          if (response.data === true) {
            this.currentPasswordCorrect = true;
            if (this.newPassword === this.confirmPassword) {
              this.newPasswordsMatch = true;
              Api()
                .put("/contacts/resetPassword/" + this.$store.state.user.id, {
                  name: this.$store.state.user.name,
                  surname: this.$store.state.user.surname,
                  idNumber: this.$store.state.user.idNumber,
                  mobileNumber: this.$store.state.user.mobileNumber,
                  password: this.confirmPassword,
                  Password: this.confirmPassword,
                  telephoneNumber: this.$store.state.user.telephoneNumber,
                  emailAddress: this.$store.state.user.emailAddress,
                  isActive: this.$store.state.user.isActive,
                })
                .then((response) => {
                  this.resetPasswordDialog = false;
                });
            } else {
              this.newPasswordsMatch = false;
            }
          } else {
            this.currentPasswordCorrect = false;
            if (this.newPassword === this.confirmPassword) {
              this.newPasswordsMatch = true;
            } else {
              this.newPasswordsMatch = false;
            }
          }
        });
    },
    formatDate(date) {
      if (date !== null) {
        return dateformat(date, "yyyy-mm-dd");
      } else {
        null;
      }
    },
    getAccounts() {
      Api()
        .get("/serviceAccounts/endUser/active/" + this.$store.state.user.id)
        .then((response) => {
          this.activeAccounts = response.data;
          if(this.activeAccounts.length>0){
            this.selectedServiceAccountIndex = 0
          }
        });
    },
     async getServiceAccounts() {
      await Api()
        .get(
          "/endUser/serviceAccounts/" +
            this.$store.state.user.id
        )
        .then(response => {
          this.activeAccounts = response.data;
          if(this.activeAccounts.length>0){
          this.selectedServiceAccountIndex = 0
          }
        });
    },
    getChangeRequests() {
      Api()
        .get("/endCustomerRequests/byContact/" + this.$store.state.user.id)
        .then((response) => {
          this.changeRequests = response.data;
        });
    },
    fetchLocations() {
      Api()
        .get("/locationContact/byContactOnly/" + this.$store.state.user.id)
        .then((response) => {
          this.allLocations = response.data;
          this.key++;
        });
    },
    fetchContactInfo() {
      Api()
        .get("/endUser/basic/" + this.$store.state.user.id)
        .then((response) => {
          this.contact = response.data;
        });
    },
    fetchInitialContactInfo() {
      Api()
        .get("/endUser/basic/" + this.$store.state.user.id)
        .then((response) => {
          this.initial = response.data;
        });
    },
    editContactInfo() {
      this.editingContact = !this.editingContact;
      this.contactChangedObj = {};
      if (this.contact.name !== this.initial.name) {
        this.contactChangedObj.name = this.contact.name;
      }
      if (this.contact.surname !== this.initial.surname) {
        this.contactChangedObj.surname = this.contact.surname;
      }
      if (this.contact.idNumber !== this.initial.idNumber) {
        this.contactChangedObj.idNumber = this.contact.idNumber;
      }
      if (this.contact.mobileNumber !== this.initial.mobileNumber) {
        this.contactChangedObj.mobileNumber = this.contact.mobileNumber;
      }
      if (this.contact.telephoneNumber !== this.initial.telephoneNumber) {
        this.contactChangedObj.telephoneNumber = this.contact.telephoneNumber;
      }
      if (this.contact.emailAddress !== this.initial.emailAddress) {
        this.contactChangedObj.emailAddress = this.contact.emailAddress;
      }
      if (this.contact.ficaDocument !== this.initial.ficaDocument) {
        this.contactChangedObj.ficaDocument = this.contact.ficaDocument;
      }
      if (this.contact.idDocument !== this.initial.idDocument) {
        this.contactChangedObj.idDocument = this.contact.idDocument;
      }
      Api()
        .put("/userPortal/contacts/" + this.$store.state.user.id, {
          batch: this.contactChangedObj,
        })
        .then((response) => {
          this.snackbar = true;
          this.text = "Info Successfully Saved!";
        });
    },
  },
};
</script>